<div mat-dialog-content>
  <form [formGroup]="roleGroup">
    <br>
    <ng-template matStepLabel>Select Roles</ng-template>
    <mat-form-field>
      <mat-label>Roles</mat-label>
      <mat-select formControlName="firstCtrl" multiple>
        <mat-option *ngFor="let role of roles" [value]="role.id">
          {{role.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div>
      <button (click)="save()" color="primary" mat-button>Save</button>
    </div>
  </form>
</div>
